import form from '../entry-form/form';
import manageGrantReports from './manager.js';
import myGrantReports from './index.js';
import { Router } from '@/legacy/Router';

Router.get('grant-report/manager', manageGrantReports);
Router.get('grant-report/entrant', myGrantReports);
Router.get('grant-report/manager/start', form);
